import { BaseModel } from "../Generics/BaseModel"

export class ReviewController extends BaseModel {
  rating: number = 0
  reviewList: Review[] = []

  constructor(data: Partial<ReviewController> = {}) {
    super()

    this.rating = data.rating || 0

    this.reviewList = data.reviewList || []
  }

  isEmpty() {
    return this.reviewList.length === 0
  }
}

export class Review {
  rating: number = 0
}
